"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Inbox_1 = __importDefault(require("@mui/icons-material/Inbox"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const requestListQuery_1 = require("../../../../queries/requestListQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const zustandStore_1 = require("../../../../zustandStore");
const requestMenuItem_1 = __importDefault(require("./requestMenuItem"));
const moveNewRequestToFirstInListIfExists = (requests) => {
    if (!Array.isArray(requests)) {
        return [];
    }
    const index = requests.findIndex(item => item.state === 'CREATED');
    if (index === 0) {
        return requests;
    }
    if (index !== -1 && requests[index]) {
        return [requests[index], ...requests.slice(0, index), ...requests.slice(index + 1)];
    }
    return requests;
};
const RequestListMenu = () => {
    const { requestId } = (0, react_router_1.useParams)();
    const { data: requests, isLoading } = (0, requestListQuery_1.useGetRequestListQuery)();
    const { data: selectedTeamId } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const { setRequests } = (0, zustandStore_1.useZustand)();
    const zustandRequests = (0, zustandStore_1.useZustand)(state => state.request.requests);
    const { streamData: data } = (0, zustandStore_1.useZustand)(state => state.stream);
    const userId = (0, zustandStore_1.useZustand)(state => state.user?.userId);
    (0, react_1.useEffect)(() => {
        if (requests && requests.length > 0) {
            let updatedRequests = requests.filter(request => !request.isArchived);
            if (data && data.events) {
                data.events.forEach(event => {
                    const eventRequestId = event.requestId;
                    const eventTeamId = event.data.teamId;
                    const eventRequester = event.data.requester?.userId;
                    const exists = updatedRequests?.some(request => request.requestId === eventRequestId);
                    if (!exists && eventTeamId === selectedTeamId?.[0] && eventRequester === userId) {
                        updatedRequests.push(event.data);
                    }
                });
            }
            updatedRequests = updatedRequests.map(request => {
                const hasUnreadMessages = data.events?.some(event => event.requestId === request.requestId);
                return {
                    ...request,
                    unread: hasUnreadMessages && requestId !== request.requestId,
                };
            });
            setRequests(moveNewRequestToFirstInListIfExists(updatedRequests));
        }
    }, [requests, data, requestId, selectedTeamId, userId]);
    if (isLoading) {
        return ((0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", mt: 2, children: [(0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}), (0, jsx_runtime_1.jsx)(material_1.Typography, { mt: 2, color: "white", children: "Loading..." })] }));
    }
    if (!zustandRequests) {
        return null;
    }
    const groupedData = lodash_1.default.groupBy(zustandRequests, 'teamId');
    const teamRequests = groupedData[selectedTeamId?.[0] || ''] || [];
    return ((0, jsx_runtime_1.jsx)(material_1.MenuList, { "data-testid": "my-requests-list", children: teamRequests.length === 0 ? ((0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", mt: 2, children: [(0, jsx_runtime_1.jsx)(Inbox_1.default, { style: { color: 'white' }, fontSize: "large" }), (0, jsx_runtime_1.jsx)(material_1.Typography, { color: "white", children: "No requests to show" })] })) : (teamRequests.map(request => (0, jsx_runtime_1.jsx)(requestMenuItem_1.default, { request: request }, request.requestId))) }));
};
exports.default = RequestListMenu;
